import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { setZoomOpen } from '../store/productSlice'

const PdpZoom = () => {
  const dispatch = useDispatch()
  const { product, zoomOpen, zoomImageId } = useSelector((state) => state.product)
  document.querySelector('[data-media-zoom]').style.display = `${zoomOpen ? '' : 'none'}`
  if(zoomOpen)
    document.body.classList.add('overflow-hidden')
  else
    document.body.classList.remove('overflow-hidden')
  setTimeout(() => {
    const mediaZoomWrapper = document.querySelector('[data-media-zoom-swiper]')
    if(product) {
      const mediaSwiper = new Swiper(mediaZoomWrapper, {
        zoom: {
          maxRatio: 5
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          320: {
            zoom: {
              maxRatio: 5
            },
          },
          1024: {
            zoom: false,
          }
        },
      })
      if(zoomImageId) {
        const slideIndex = mediaZoomWrapper.querySelector(`[data-image-id="${zoomImageId}"]`).dataset.index
        mediaSwiper.slideTo(slideIndex)
      }
      mediaSwiper.on('slideChange', () => {
        if(mediaSwiper.pagination && mediaSwiper.pagination.bullets.length > 0) {
          mediaZoomWrapper.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, index) => {
            if(index == mediaSwiper.activeIndex)
              bullet.classList.add('swiper-pagination-bullet-active')
            else
              bullet.classList.remove('swiper-pagination-bullet-active')
          })
        }
      })
    }
  }, 300)

  return (
    <div className='mt-12 lg:mt-0'>
      {
        product && product.media.length > 0 &&
        <div className='overflow-hidden' data-media-zoom-swiper>
          <div className='swiper-wrapper lg:-top-16'>
            {
              product.media.map((image, index) => 
                <div className='swiper-slide' data-image-id={image.id} data-index={index} key={`zoom-${image.id}-${index}`}>
                  <div class="swiper-zoom-container">
                    {image.media_type.toLowerCase() == 'image' && <img className='w-full' src={image.src} alt={ image.alt } loading="lazy" />}
                    {image.media_type.toLowerCase() == 'external_video' && image.host == 'vimeo' &&
                      <div className='w-full relative h-0' style={{paddingBottom: `${1/image.aspect_ratio*100}%`}}>
                        <iframe src={`https://player.vimeo.com/video/${ image.external_id }?pip=0&loop=0`} className={`w-full h-full object-fill absolute left-0 top-0`} width="640" height="360" frameborder="0" allow="fullscreen;" allowFullScreen={true}></iframe>
                      </div> 
                    }
                  </div>
                </div>
              )
            }
          </div>
          { product && product.media.length > 1 && 
            <div className="swiper-pagination !fixed !top-12 px-3 lg:px-10 !bottom-[initial] grid gap-0.5 h-0.5 z-10" 
              style={ { gridTemplateColumns: `repeat(${product.media.length},minmax(0,1fr))` } } /> }
          {
            product && product.media.length > 1 && <div className="swiper-button-prev !left-4 !top-1/2 after:!hidden !h-auto !flex !text-black" dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-arrow'] }} />
          }
          {
            product && product.media.length > 1 && <div className="swiper-button-next !right-4 !top-1/2 after:!hidden !h-auto !flex !text-black" dangerouslySetInnerHTML={{ __html: window.globalIcons['icon-arrow-right'] }} />
          }
        </div>
      }
      <button className='text-light-blue fixed top-3.5 left-3 lg:left-10 text-base z-10' onClick={() => dispatch(setZoomOpen(false))}>
        Close
      </button>
    </div>
  )
}

export default PdpZoom